/**
 * Access model: 7-day full trial from signup, then paid.
 * Numeric "free caps" are retired — unpaid users are gated by isPremium / trial, not item limits.
 */

export const TRIAL_DAYS = 7;

/** @deprecated Kept for call sites; caps are no longer enforced. */
export const FREE_PLAN_DAYS = 365;
/** @deprecated Kept for call sites; caps are no longer enforced. */
export const FREE_RECIPE_CAP = Number.MAX_SAFE_INTEGER;
/** @deprecated Kept for call sites; caps are no longer enforced. */
export const FREE_LIST_CAP = Number.MAX_SAFE_INTEGER;
/** @deprecated Kept for call sites; caps are no longer enforced. */
export const FREE_LIST_ITEM_CAP = Number.MAX_SAFE_INTEGER;

/**
 * Category hubs on the meals launch surface (and legacy free home).
 * Non-meal hubs stay hidden while MEALS_ONLY_PRODUCT is on.
 */
export const FREE_DASHBOARD_CATEGORY_HUBS = new Set([
  "plan",
  "lists",
  "recipes",
  "calendar",
  "automation",
  "profile",
  "meals",
]);

/** Local YYYY-MM-DD for today in the user's browser timezone. */
function localDateKey(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Firestore Timestamp | Date | string | number → Date | null */
export function toTrialDate(value) {
  if (!value) return null;
  if (typeof value.toDate === "function") return value.toDate();
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function getDefaultTrialEndsAt(from = new Date()) {
  const end = new Date(from.getTime());
  end.setDate(end.getDate() + TRIAL_DAYS);
  return end;
}

export function isTrialActive(trialEndsAt, now = new Date()) {
  const end = toTrialDate(trialEndsAt);
  return !!(end && end.getTime() > now.getTime());
}

export function trialDaysRemaining(trialEndsAt, now = new Date()) {
  const end = toTrialDate(trialEndsAt);
  if (!end) return 0;
  const ms = end.getTime() - now.getTime();
  if (ms <= 0) return 0;
  return Math.ceil(ms / (24 * 60 * 60 * 1000));
}

/**
 * Planning dates are always allowed now (trial/paid gate lives in SubscriptionContext).
 */
export function isFreePlanDateAllowed(dateKey, isPremium = false) {
  if (isPremium || !dateKey) return true;
  const today = localDateKey();
  if (dateKey < today) return true;
  const end = new Date();
  end.setHours(0, 0, 0, 0);
  end.setDate(end.getDate() + (FREE_PLAN_DAYS - 1));
  return dateKey <= localDateKey(end);
}
